import { useEffect } from 'react'

export function useRemovePreloader() {
  useEffect(() => {
    const loader = document.querySelector('#preloader')

    let removeTimeoutId: number
    if (loader) {
      loader.classList.add('hidden')
      removeTimeoutId = window.setTimeout(() => {
        loader.remove()
        document.querySelector('#preloader-styles')?.remove()
      }, 1000)
    }

    return () => {
      if (removeTimeoutId) {
        clearTimeout(removeTimeoutId)
      }
    }
  }, [])
}
